import { hasNativeTranslator, nativeTranslatorBackend } from "@/main/mobile-shell/MobileTranslateBridge";
import { chromeTranslatorBackend, hasChromeTranslator } from "@/main/translation/chromeTranslatorBackend";
import type { TranslatorBackend } from "@/main/translation/TranslatorBackend";

/**
 * Whether ANY on-device translator exists here. Synchronous feature detection, cheap enough for the
 * eager graph: a host asks it before rendering the lazy translate control, so a browser with no
 * backend never fetches the control's chunk at all (rule 27).
 */
export function hasTranslatorBackend(): boolean {
    return hasNativeTranslator() || hasChromeTranslator();
}

/**
 * The backend to use, native first (A2). The Android WebView has no `Translator` API, so in practice
 * the two never compete; the order only matters if a future WebView gains one.
 */
export function resolveTranslatorBackend(): TranslatorBackend | null {
    return nativeTranslatorBackend() ?? chromeTranslatorBackend();
}
